import script from "./OrderProductGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderProductGroup.vue?vue&type=script&setup=true&lang=js"

import "./OrderProductGroup.vue?vue&type=style&index=0&id=74947f72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74947f72"]])

export default __exports__